/**
 * 导出数据为CSV文件
 * @param {Array} data - 要导出的数据数组
 * @param {String} filename - 文件名（不含扩展名）
 * @param {Object} columnMap - 列映射 {原始字段名: '显示名称'}
 */
export const exportToCSV = (data, filename = '导出数据', columnMap = {}) => {
  if (!data || data.length === 0) {
    return false;
  }

  try {
    // 如果没有提供列映射，使用第一条数据的键作为列名
    const firstRow = data[0];
    const headers = Object.keys(columnMap).length > 0 
      ? Object.values(columnMap)
      : Object.keys(firstRow);

    // 准备CSV数据
    const csvRows = [
      headers.join(','),
      ...data.map(row => {
        const values = Object.keys(columnMap).length > 0
          ? Object.keys(columnMap).map(key => {
              const value = row[key];
              // 处理包含逗号、引号或换行符的值
              if (value === null || value === undefined) return '""';
              const stringValue = String(value).replace(/"/g, '""');
              return `"${stringValue}"`;
            })
          : Object.values(row).map(value => {
              if (value === null || value === undefined) return '""';
              const stringValue = String(value).replace(/"/g, '""');
              return `"${stringValue}"`;
            });
        return values.join(',');
      })
    ];

    const csvContent = csvRows.join('\n');
    
    // 创建Blob并下载
    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error('导出失败：', error);
    return false;
  }
};

